import { render, staticRenderFns } from "./WeeklyWorkLab.vue?vue&type=template&id=592a2ee6&scoped=true"
import script from "./WeeklyWorkLab.vue?vue&type=script&lang=js"
export * from "./WeeklyWorkLab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592a2ee6",
  null
  
)

export default component.exports